export default "__VITE_ASSET__c7lJQ8caTm8Y7COGVvNbJg__";